import React, { useState, useEffect } from 'react';
import ItemComboBoxAdjLabel, { ComboBoxItemType } from '../ComboBox/ItemComboBoxAdjLabel';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { debug, LogD } from '../../../function/LogLapper';
import dayjs from 'dayjs';
import DateInput from '../../atoms/Calendar/DateInput';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    tableTd: {
      fontSize: '15px',
    },
    textField: {
      width: 200,
    },
    //style for font size
    resize: {
      fontSize: '15px',
    },

    labelStyle: {
      fontSize: '22px',
    },
    itemBoxStyle: {
      fontSize: '13px',
    },
  })
);

//時刻リスト作成
const CreateTimeList = (min: number, max: number): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  for (let i = min; i <= max; i++) {
    ret.push({ index: i, name: `${('00' + i).slice(-2)}` });
  }
  //console.debug(['ret', ret]);
  return ret;
};

type Props = {
  labelCssString?: string;
  textCssString?: string;
  label: string;
  labelPosition?: number;
  defaultValue: string; //format('YYYY-MM-DD HH:mm:ss');
  onChange: (value: string) => void;
};

/**
 * カレンダー（TextField）に時刻コンボボックスを追加したコンポーネント
 * @param props
 * @returns
 */
const ItemCalenderTimeEx: React.FC<Props> = (props) => {
  //console.debug(['- ItemCalenderTimeEx props -', props]);

  const { labelPosition = 1 } = props;
  const classes = useStyles();

  const [year, setYear] = useState<number>(0);
  const [month, setMonth] = useState<number>(0);
  const [date, setDate] = useState<number>(0);
  const [hour, setHour] = useState<number>(0);
  const [minute, setMinute] = useState<number>(0);
  const [second, setSecond] = useState<number>(0);
  const [editValue, setEditValue] = useState<string>(props.defaultValue);

  const [hoursList, setHoursList] = React.useState<ComboBoxItemType[]>([]);
  const [minutesList, setMinutesList] = React.useState<ComboBoxItemType[]>([]);

  //コンボボックスデータ作成
  useEffect(() => {
    //console.debug(['useEffect 1']);
    setHoursList(CreateTimeList(0, 23));
    setMinutesList(CreateTimeList(0, 59));
  }, []);

  useEffect(() => {
    const days = dayjs(props.defaultValue);
    //console.debug(['useEffect 2', props.defaultValue, days]);
    setYear(days.year());
    setMonth(days.month() + 1);
    setDate(days.date());
    setHour(days.hour());
    setMinute(days.minute());
    setSecond(days.second());
    setEditValue(props.defaultValue);
  }, [props.defaultValue]);

  // /**
  //  * 時刻を　yyyy-MM-ddThh:mm　フォーマットで返す
  //  * @param value
  //  * @returns
  //  */
  // const convertDatetimeLocalFormat = (value: string) => {
  //   const timeStr = dayjs(value).format('YYYY-MM-DDTHH:mm');
  //   //console.debug(['convertDatetimeLocalFormat', value, timeStr]);
  //   return timeStr;
  // };

  /**
   * 時刻を　yyyy-MM-dd hh:mm　フォーマットで返す
   * @param value
   * @returns
   */
  const convertDatetime = (
    src: string,
    year: number,
    mon: number,
    date: number,
    hour: number,
    min: number,
    sec: number
  ) => {
    const timeStr = dayjs(src)
      .year(year)
      .month(mon - 1)
      .date(date)
      .hour(hour)
      .minute(min)
      .second(sec)
      .format('YYYY-MM-DD HH:mm');
    console.debug(`convertDatetime', ${src} ==> ${timeStr}`);
    return timeStr;
  };

  /**
   * 日付選択
   * format 'YYYY-MM-DD HH:mm'でコールバック
   * @param date
   */
  const ChangeDateSelect = (date: string) => {
    const conv = dayjs(date);
    //console.debug(['ChangeDateSelect', date, conv]);
    const timeStr = convertDatetime(editValue, conv.year(), conv.month() + 1, conv.date(), hour, minute, second);
    setYear(conv.year());
    setMonth(conv.month() + 1);
    setDate(conv.date());
    setEditValue(timeStr);
    props.onChange(timeStr);
  };

  /**
   * 時間選択
   * format 'YYYY-MM-DD HH:mm'でコールバック
   * @param event
   */
  const ChangeHourSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var h = hoursList.find((item) => item.index === Number(event.target.value));
    //console.debug('ChangeHoursSelect -- ', h);
    if (h !== undefined) {
      const timeStr = convertDatetime(editValue, year, month, date, h.index, minute, second);
      setHour(h.index);
      setEditValue(timeStr);
      props.onChange(timeStr);
    }
  };

  /**
   * 分選択
   * format 'YYYY-MM-DD HH:mm'でコールバック
   * @param event
   */
  const ChangeMinuteSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var min = minutesList.find((item) => item.index === Number(event.target.value));
    //console.debug('ChangeMinuteSelect -- ', min);
    if (min !== undefined) {
      const timeStr = convertDatetime(editValue, year, month, date, hour, min.index, second);
      setMinute(min.index);
      setEditValue(timeStr);
      props.onChange(timeStr);
    }
  };

  return (
    <Box component="span" display="inline-flex" alignItems="center">
      {labelPosition === 1 && <div className={props.labelCssString ?? classes.tableTd}> {props.label}</div>}
      <form className={classes.container} noValidate>
        {/* カレンダー */}
        <DateInput
          labelCssString={classes.labelStyle}
          initialValue={dayjs(editValue).format('YYYY-MM-DD')}
          label={''}
          labelPosition={1}
          onDateChange={(event) => {
            console.debug('onChange', event);
            if (event !== '') {
              ChangeDateSelect(event);
            }
          }}
        ></DateInput>
        {<div style={{ "width": "20px" }}>

        </div>}
        {/* 時間 */}
        <ItemComboBoxAdjLabel
          label={''}
          labelPosition={1}
          itemList={hoursList}
          value={hour}
          labelStyle={classes.labelStyle}
          itemBoxStyle={classes.itemBoxStyle}
          onChangeEvent={ChangeHourSelect}
        />

        {/* 分 */}
        <ItemComboBoxAdjLabel
          label={': '}
          labelPosition={1}
          itemList={minutesList}
          value={minute}
          labelStyle={classes.labelStyle}
          itemBoxStyle={classes.itemBoxStyle}
          onChangeEvent={ChangeMinuteSelect}
        />
      </form>
      {labelPosition === 2 && <div className={props.labelCssString ?? classes.tableTd}> {props.label}</div>}
    </Box>
  );
};
export default ItemCalenderTimeEx;
